var render = function () {
  var _vm$purchase, _vm$purchase$product;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.purchase ? _c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상품리뷰")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('section', {
    staticClass: "page-section page-section--sm pt-0"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "border"
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$purchase = _vm.purchase) === null || _vm$purchase === void 0 ? void 0 : (_vm$purchase$product = _vm$purchase.product) === null || _vm$purchase$product === void 0 ? void 0 : _vm$purchase$product.thumb,
      "max-width": "100",
      "aspect-ratio": 1 / 1,
      "contain": ""
    }
  })], 1)]), _c('v-col', [_c('div', {
    staticClass: "mx-2 text-truncate"
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.purchase.product.name)
    }
  })]), _vm.purchase.product.type == 'option' ? _c('div', {
    staticClass: "mx-2 text-truncate"
  }, [_vm._v("[" + _vm._s(_vm.purchase.product.optionalNames.toString()) + "] : " + _vm._s(_vm.purchase.product.optionalValues.toString()))]) : _vm._e()])], 1)], 1), _c('section', {
    staticClass: "page-section page-section--sm"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("별점")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('v-rating', {
    attrs: {
      "label": "별점",
      "color": "yellow darken-1",
      "background-color": "grey",
      "dense": "",
      "length": "5"
    },
    model: {
      value: _vm.review.rating,
      callback: function callback($$v) {
        _vm.$set(_vm.review, "rating", $$v);
      },
      expression: "review.rating"
    }
  })], 1), _c('section', {
    staticClass: "page-section page-section--sm pb-0"
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "후기를 작성해주세요",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.review.content,
      callback: function callback($$v) {
        _vm.$set(_vm.review, "content", $$v);
      },
      expression: "review.content"
    }
  })], 1)]), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }